<body class="ltr main-body leftmenu">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="StudentDataForm">
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm add-form">
                        <div class="col-lg-12 col-md-12">
                            <div class="card custom-card">
                                <div class="card-body pb-0">
                                    <div class="col-md-12 prpl">
                                        <div class="row align-items-center">
                                            <div class="col-md-4 prpl">
                                                <div class="d-flex align-items-center">
                                                    <img alt="Logo" src="../../assets/img/attendance.png"
                                                        class="mh-45px pb-2">
                                                    <p class="mb-1">
                                                        <span class="main-content-label"><b>WithHeld Students Release
                                                                Details</b></span><br>
                                                        <span class="text-muted card-sub-title mb-0">List Of Held
                                                            Student</span>
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="col-md-8 d-flex align-items-center justify-content-end">
                                                <div class="col-sm-6" [formGroup]="StudentSearchForm">
                                                    <mat-form-field appearance="outline" class="w-100">
                                                        <mat-label>{{'header.college-data.table.Search' |
                                                            translate}}</mat-label>
                                                        <input class="color" matInput placeholder="Search"
                                                            formControlName="RegNo" (keyup.enter)="searchByPrn()">
                                                        <mat-icon matSuffix>search</mat-icon>
                                                    </mat-form-field>
                                                    <!-- </div> -->
                                                </div>
                                            </div>
                                        </div>

                                        <hr class="mt-2">
                                        <div class="row clearfix mt-3">
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Session</mat-label>
                                                        <mat-select #select232 placeholder="Session" class="colorblack"
                                                            formControlName="SessionId">
                                                            <mat-select-filter *ngIf="select232.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'SnName'"
                                                                [array]="sessionList"
                                                                (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of SessionFilterList"
                                                                [value]="item.SnNo" (click)="getCourse(item)">
                                                                {{item.SnName}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error
                                                            *ngIf="StudentDataForm.get('SessionId').hasError('required')">
                                                            Session is required
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            Course
                                                        </mat-label>
                                                        <mat-select #select55 class="colorblack"
                                                            formControlName="course">
                                                            <mat-select-filter *ngIf="select55.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CoName'"
                                                                [array]="CourseList"
                                                                (filteredReturn)="filteredListCourse =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListCourse"
                                                                [value]="item.CoCode" (click)="getCollege(item)">
                                                                {{item.CoCode}} - {{item.CoName}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error
                                                            *ngIf="StudentDataForm.get('course').hasError('required')">
                                                            Course is required
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            College
                                                        </mat-label>
                                                        <mat-select #select23 formControlName="college"
                                                            [displayMember]="'CgName'">
                                                            <mat-select-filter *ngIf="select23.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CgName'"
                                                                [array]="collegeList"
                                                                (filteredReturn)="filteredCollegeList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredCollegeList"
                                                                [value]="item.CgCode">
                                                                {{item.CgCode}} - {{item.CgName}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error
                                                            *ngIf="StudentDataForm.get('college').hasError('required')">
                                                            College is required
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            Exam
                                                        </mat-label>
                                                        <mat-select #select2398 placeholder="Exam"
                                                            formControlName="EmId"
                                                            (selectionChange)="getStudentHoldData($event.value)">
                                                            <mat-select-filter *ngIf="select2398.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'EmName'"
                                                                [array]="examList"
                                                                (filteredReturn)="filteredListExam =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListExam"
                                                                [value]="item.EmId">
                                                                {{item.EmCoCode}}-{{item.EmName}}
                                                            </mat-option>

                                                        </mat-select>
                                                        <mat-error
                                                            *ngIf="StudentDataForm.get('EmId').hasError('required')">
                                                            Exam is required
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <!-- <div class="col-sm-2" *ngIf="isBranch">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            Branch
                                                        </mat-label>
                                                        <mat-select #select23 placeholder="Branch"
                                                            formControlName="Branch">
                                                            <mat-select-filter *ngIf="select23.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'EmName'"
                                                                [array]="BranchList"
                                                                (filteredReturn)="filteredListBranch =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListBranch"
                                                                [value]="item.StrId" (click)="getStr(item)">
                                                                {{item.StrName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div> -->
                                        </div>
                                        <hr class="mt-2">
                                        <div class="row align-items-center">
                                            <div *ngIf="Table" class="col-sm-9">
                                                <div *ngIf="message; else cut" class="mb-3">
                                                    <p style="color: green;"><b>{{message}}</b></p>
                                                </div>
                                                <ng-template #cut>
                                                    <div class="mb-3">
                                                        <p style="color: red;"><b>{{closeMessage}}</b></p>
                                                    </div>
                                                </ng-template>
                                            </div>
                                            <!-- <div *ngIf="Table" class="col-sm-3" [formGroup]="IAMarksForm">
                                                <mat-form-field appearance="outline" class="w-100">
                                                    <mat-label>{{'header.college-data.table.Search' |
                                                        translate}}</mat-label>
                                                    <input class="color" matInput placeholder="Search"
                                                        (keyup)="keypress()" formControlName="SearchString">
                                                    <mat-icon matSuffix>search</mat-icon>
                                                </mat-form-field>
                                            </div> -->
                                        </div>

                                        <div class="table-responsive custom-table" *ngIf="displayedColumns.length">

                                            <!-- <div class="mb-2" style="text-align: right; margin-right: 100px;">
                                                <mat-checkbox [(ngModel)]="selectAll"
                                                    (change)="selectAllData($event.checked)">
                                                    Select All
                                                </mat-checkbox>
                                            </div> -->
                                            <table mat-table [dataSource]="dataSource" class="mat-elevation-z2">

                                                <ng-container *ngFor="let column of columns"
                                                    [matColumnDef]="column.field">

                                        <th mat-header-cell *matHeaderCellDef>
                                            <ng-container *ngIf="column.field === 'Release'; else normalHeader">
                                        
                                                <div class="release-header">
                                                    <span class="release-title">Release</span>
                                        
                                                    <mat-checkbox [(ngModel)]="selectAll" [ngModelOptions]="{ standalone: true }"
                                                        (change)="selectAllData($event.checked)">
                                                        Select All
                                                    </mat-checkbox>
                                                </div>
                                        
                                            </ng-container>
                                        
                                            <ng-template #normalHeader>
                                                {{ column.header }}
                                            </ng-template>
                                        </th>
                                                    <td mat-cell *matCellDef="let row" [class.release-cell]="column.field === 'Release'">

                                                        <mat-checkbox *ngIf="column.field === 'Release'"
                                                            [(ngModel)]="row.selected"
                                                            [ngModelOptions]="{ standalone: true }"
                                                            (change)="row.selected = $event.checked">

                                                        </mat-checkbox>

                                                        <!-- Normal columns -->
                                                        <span *ngIf="column.field !== 'Release'">
                                                            {{ row[column.field] }}
                                                        </span>

                                                    </td>

                                                </ng-container>

                                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

                                                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

                                            </table>
                                            <div class="py-2 d-flex justify-content-end gap-2 me-3">

                                                <button type="button" class="btn btn-primary"
                                                    (click)="saveInactiveData()">
                                                    <i class="fa fa-save me-1"></i>
                                                    Save
                                                </button>
                                                <button type="button" class="btn btn-primary"
                                                    (click)="cancelSelection()">
                                                    <i class="fa fa-times me-1"></i>
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>
